import {
  OrderStatusSchema,
  type OrderStatus as GeneratedOrderStatus
} from '~/services/api/generated'

export type OrderStatus = GeneratedOrderStatus

type FacadeKey<Value extends string> = Value extends `${infer Prefix} ${infer Suffix}`
  ? `${Uppercase<Prefix>}_${FacadeKey<Suffix>}`
  : Uppercase<Value>

type OrderStatusFacade = {
  [Value in OrderStatus as FacadeKey<Value>]: Value
}

const statusValue = <Value extends OrderStatus>(value: Value): Value => {
  OrderStatusSchema.parse(value)
  return value
}

export const OrderStatus = {
  ACCEPTED: statusValue('Accepted'),
  CANCELLED: statusValue('Cancelled'),
  DECLINED: statusValue('Declined'),
  COMPLETED: statusValue('Completed'),
  CONFIRMED: statusValue('Confirmed'),
  DELIVERED: statusValue('Delivered'),
  PAYMENT_FAILED: statusValue('Payment Failed'),
  IN_PROGRESS: statusValue('in_progress'),
  PENDING: statusValue('Pending'),
  PREPARING: statusValue('Preparing'),
  READY: statusValue('Ready')
} satisfies OrderStatusFacade

export const OrderStatusValues: readonly OrderStatus[] = OrderStatusSchema.options
